import { titleCase } from './SqliteHelp.js'
export function makeEditControllersCode(dbName, tableName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    return makeCode(tableName,tableDatas)
}

export function makeCode(tableName,tableDatas) {

  let dataForm = `
  /// 数据表单
  Map dataForm = {`
  tableDatas[tableName].forEach(tableItem => {
    dataForm = dataForm + `
    "${tableItem.name}": null,`
  })
  dataForm = dataForm + `
  };`

  let cleanDataForm = `
  /// 数据表单
  Map cleanDataForm = {`
  tableDatas[tableName].forEach(tableItem => {
    cleanDataForm = cleanDataForm + `
    "${tableItem.name}": null,`
  })
  cleanDataForm = cleanDataForm + `
  };`

  let fieldTextEditing = ``
  tableDatas[tableName].forEach(tableItem => {
    if (tableItem.name != 'id') {
    fieldTextEditing = fieldTextEditing + `
  TextEditingController ${tableItem.name} = TextEditingController();`
    }
  })

  let fieldSet = ``
  let fieldSave = ``
  tableDatas[tableName].forEach(tableItem => {
    if (tableItem.name != 'id') {
    fieldSet = fieldSet + `
        ${tableItem.name}.text = dataForm['${tableItem.name}'] != null ? dataForm['${tableItem.name}'].toString() : '';`
    
    if (tableItem.typ == 'INTEGER PRIMARY KEY AUTOINCREMENT') {
      fieldSave = fieldSave + `
    if (${tableItem.name}.text != null && ${tableItem.name}.text != '' && ${tableItem.name}.text != 'null'){
      dataForm['${tableItem.name}'] = int.parse(${tableItem.name}.text);
    } else {
      dataForm['${tableItem.name}'] = '';
    }`
    } else if (tableItem.typ == 'INTEGER') {
      fieldSave = fieldSave + `
    if (${tableItem.name}.text != null && ${tableItem.name}.text != '' && ${tableItem.name}.text != 'null'){
      dataForm['${tableItem.name}'] = int.parse(${tableItem.name}.text);
    } else {
      dataForm['${tableItem.name}'] = '';
    }`
    } else if (tableItem.typ == 'FLOAT') {
      fieldSave = fieldSave + `
    if (${tableItem.name}.text != null && ${tableItem.name}.text != '' && ${tableItem.name}.text != 'null'){
      dataForm['${tableItem.name}'] = double.parse(${tableItem.name}.text);
    } else {
      dataForm['${tableItem.name}'] = '';
    }`
    } else {
      fieldSave = fieldSave + `
    dataForm['${tableItem.name}'] = ${tableItem.name}.text;`
    }
  }
  })

  return `/// Author: Samle
import 'package:flutter/cupertino.dart';
import 'package:get/get.dart';

class Edit${titleCase(tableName)}Controller extends GetxController {

  /// 获取Key用来获取Form表单组件
  GlobalKey<FormState> edit${titleCase(tableName)}Key = GlobalKey<FormState>();${fieldTextEditing}
  ${dataForm}
  ${cleanDataForm}

  /// 获取数据
  getData() async {
    try {
      if (Get.arguments.isNotEmpty && Get.arguments != null){
        dataForm = Get.arguments;${fieldSet}
      }
    } catch (e) {
      print("数据获取失败");
    } finally {
    }
  }

  /// 返回数据
  saveData() {${fieldSave}
    Get.back(result: dataForm);
  }

  @override
  void onInit() {
    getData();
    super.onInit();
  }

  @override
  void onReady() {
    super.onReady();
  }

  @override
  void onClose() {
    super.onClose();
  }
}
`
}